import { createContext } from 'react';

import type {
  TableLevel,
  TableSize,
  TableSpacing,
  TableVariant,
} from '../types';

export interface TableContextType {
  level: TableLevel;
  size: TableSize;
  spacing: TableSpacing;
  stickyHeader: boolean;
  variant: TableVariant;
}

export const TableContext = createContext<TableContextType | undefined>(
  undefined,
);

TableContext.displayName = 'TableContext';
